<template>
  <div class="subTabClass" v-if="chartData1 !== null && chartData1.length">
    <PlotlyMultiLineBarChart
      class="svgChart"
      :data-set="chartData1"
      :xAxisType="xAxisType"
      :yAxisType="yAxisType"
      :margin="margin"
      :title="chartTitle"
      :name="name"
      :chartWidth="chartWidth"
      :chartHeight="chartHeight" 
      :tickFormat="tickFormat"
      :tickFormatY2="tickFormatY2"
      :commitName="'PPI Finished goods'"
    >
    </PlotlyMultiLineBarChart>
    <div class="sourceTabWrapper">
      <h6 class="sourceTab">
        % (derived from Chicago Fed National Activity Index)
      </h6>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
//------------Import Charts----------
import PlotlyMultiLineBarChart from "@/components/charts/PlotlyCharts/MultiLineBarChart.vue";

export default {
  name: "PPI_Finished_goods",
  components: {
    PlotlyMultiLineBarChart,
  },
  computed: {
    ...mapGetters({
      ppifinishedgoods: "ppifinishedgoods",
      historyCalDropDown: "historyCalDropDown",
    }),
    /*chartData1(){
      //return this.ppifinishedgoods;
    }*/
  },
  data() {
    return {
      chartTitle: "",
      name: "PPI_Finished_goods",
      yAxisType: "linear",
      xAxisType: "date",
      chartWidth: 1200,
      chartHeight: 330,
      tickFormat:",.0%",
      tickFormatY2:"",
      chartData: [],
      chartData1:[],
      margin: {
        l: 80,
        r: 80,
        b: 120,
        t: 40,
        pad: 2,
      },
    };
  },
  created() {
    this.getChartData();
  },
  methods: {
    ...mapActions(["getIframeChartDataById", "currentVersionUpdateHandler"]),
    unpack(rows, key) {
      return rows.map(function (row) {
        return row[key];
      });
    },

    async getChartData() {
      let chart_API_Data = [];
      if (window.location.href.includes("auth_token=") && !this.ppifinishedgoods.length) {
        let data = await this.getIframeChartDataById(44);
        chart_API_Data = data;
      } else {
        chart_API_Data = this.ppifinishedgoods;
      }
      //------------Formatted Data------------
      if(chart_API_Data && chart_API_Data.length){
      let formattedData = chart_API_Data.map(function (i) {
        return {
          lineField: i.ppi,
          barField: (i.recessions)/100,
          xField: i.date,
          year: i.year,
        };
      });

      formattedData.reverse();

      //------------Line Charts------------
      let trace1 = {
        type: "bar",
        name: "Recession",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "barField"),
        year:this.unpack(formattedData, "year"),
        xaxis: "x",
        yaxis: "y",
        marker: {
          color: "rgb(218, 214, 214)",
        },
      };

      let trace2 = {
        type: "scatter",
        mode: "lines",
        name: "PPI Intermediate Goods/Crude Materials Ex-Ag",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField"),
        xaxis: "x",
        yaxis: "y2",
        year:this.unpack(formattedData, "year"),
        line: {
          color: "#52bcd3",
        },
      };
      setTimeout(() => {
        if(trace1 && trace2){
          this.chartData1 = [trace1, trace2];
        }
      }, 10);
    }
    },
  },
  watch: {
    ppifinishedgoods: {
        deep: true,
        handler() {
          this.chartData1 = null;
          this.getChartData();
          // this.loadChartData();
          // console.log("api responceeeeeeeeeeee", this.sectorValuations);
        }
    }
  },
  destroyed() {
    // console.log("destroyed++++", this.commitName);
    let payLoadObj = {
      table_pk: this.selected,
      chart_id: this.historyCalDropDown.current_version.chart_id,
      chartName: this.commitName,
    };
    let version = {
      version_data: payLoadObj,
      versionToggleValue: false,
    };
    this.currentVersionUpdateHandler(version);
  },
};
</script>
